var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#27323A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8392 3.375C13.8392 3.375 14.7656 4.1985 14.1081 5.87419C13.9831 6.18222 13.8095 6.46822 13.5939 6.72131L11.3074 9.40444L9.4725 11.7996C9.4725 11.7996 7.36537 11.4531 6.54637 12.303L10.0192 12.4571C10.0192 12.4571 9.27787 13.2688 6.35175 12.6877C6.35175 12.6877 6.39112 13.5023 7.71806 13.734C7.71806 13.734 6.54638 14.1216 5.84381 12.9988C5.84381 12.9988 5.84381 13.8133 6.66281 14.1598C6.66281 14.1598 5.99906 14.3139 5.45231 13.6181L4.51687 14.6216C4.51687 14.6216 4.32281 14.6604 4.43925 14.4681L5.21944 13.5411C5.21944 13.5411 5.29706 12.8835 4.82794 13.1147C4.82794 13.1147 4.51688 13.23 4.63331 13.5793C4.63331 13.5793 4.16419 13.1946 4.7115 12.6911L3.65625 11.646L5.022 12.3801L4.43644 10.9496L5.41069 12.1877C5.41069 12.1877 5.32969 10.7961 5.76056 10.4107C5.76056 10.4107 5.877 11.7641 6.42431 11.88L6.38494 9.05737L6.97106 8.5545L7.04869 10.3309C7.04869 10.3309 7.20394 10.5233 7.35919 10.2926C7.35919 10.2926 7.71187 9.71213 7.71187 8.01225L8.64731 7.1235L8.76431 7.81988C8.76431 7.81988 8.92238 8.08931 9.117 7.85813L9.31106 6.50531C9.31106 6.50531 10.5598 5.07487 13.8392 3.375ZM7.59544 11.2219C10.8321 8.24625 12.5511 5.34712 12.5477 5.34712C10.9491 6.4665 7.59544 11.2219 7.59544 11.2219Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtc);
export default __webpack_public_path__ + "static/media/ftc.3b6e1465a242fc284fc1c079806fceda.svg";
export { ForwardRef as ReactComponent };